import React from 'react';
import styles from './TeamMemberTextOnlyCard.module.css';

function TeamMemberTextOnlyCard({ name, role, linkedin }) {
  return (
    <div className={styles.card}>
      <div className={styles.cardInner}>
        <h4 className={styles.name}>{name}</h4>
        <p className={styles.role}>{role}</p>
        {linkedin && (
          <a href={linkedin} target="_blank" rel="noopener noreferrer" className={styles.link}>
            LinkedIn
          </a>
        )}
      </div>
    </div>
  );
}

export default TeamMemberTextOnlyCard;
